define(
    'viewmodels/secured/explorer/navigation/navigation',[
        "viewmodels/secured/explorer/context",
        "viewmodels/ViewModel",
        "providers/dataprovider",
        "viewmodels/secured/explorer/navigation/menu",
        "services/service.documents",        
        "i19n!i19n/strings"
    ],
    function(ctx, ViewModel, dataProvider, menu, documentsService, i19n) {

        var vm = new ViewModel(
        {
            hasCodeBehind: true,
            i19n: i19n,
            
            menu: menu,           
            searchedMenuItem: new menu.Item(false,'search'),
            recentDocumentsMenuItem: new menu.Item(false, 'recent'),
            flaggedDocumentsMenuItem: new menu.Item(false, 'flagged'),
            //checkedOutDocumentsMenuItem: new menu.Item(false, 'checkedout'),

            isGuest: ko.observable(false)
        });

        //vm.menu.items([vm.searchedMenuItem, vm.recentDocumentsMenuItem, vm.flaggedDocumentsMenuItem, vm.checkedOutDocumentsMenuItem]);
        vm.menu.items([vm.searchedMenuItem, vm.recentDocumentsMenuItem, vm.flaggedDocumentsMenuItem]);

        vm.activate = function () {
            vm.isGuest(vm.session.role == 0 || vm.session.role == 1 ? true : false);
        };

        vm.recentDocumentsSelected = ko.asyncCommand({
            execute: function (complete) {
                ctx.onNavRecent(null);

                //console.warn("recentDocumentsSelected");

                complete();
            }
        });

        vm.flaggedDocumentsSelected = ko.asyncCommand({
            execute: function (complete) {
                ctx.onNavFlagged(null);

                //console.warn("flaggedDocumentsSelected");

                complete();
            }
        });

        //vm.checkedOutDocumentsSelected = ko.asyncCommand({
        //    execute: function (complete) {
        //        ctx.onNavCheckedOut(null);

        //        complete();
        //    }
        //});

        return vm;
    });
